const o = "동의", e = "축하하다", t = "완료됨", c = "동의하지 않음", n = "웃긴", s = "안녕", a = "사랑", i = "와우", l = {
  agree: o,
  celebrate: e,
  completed: t,
  disagree: c,
  funny: n,
  hi: s,
  love: a,
  wow: i
};
export {
  o as agree,
  e as celebrate,
  t as completed,
  l as default,
  c as disagree,
  n as funny,
  s as hi,
  a as love,
  i as wow
};
